import * as React from 'react';

import { SectionOfQuestions } from '../../../SeqtionOfQuestions';
import { Explain } from '../../../Explain';
import { Valuation } from '../../../Valuation';
import { HeroBannerContainer } from '../../../../containers/HeroBannerContainer';

import * as styles from './styles.css';
import { ValuationFiltersContainer } from '../../../../containers/ValuationFiltersContainer';

export const MobileView = () => {
  return (
    <div className={styles['information']}>
      <HeroBannerContainer />

      <ValuationFiltersContainer />

      <div className={styles['questions']}>
        <Explain />
        <SectionOfQuestions />
      </div>
      <Valuation />
    </div>
  );
};
